<template>
    <div class="head-wrapper">
        <div class="head-box" @click="changeTab">
            <div class="title">{{ text }}</div>
            <img v-if="hasArrow" :src="arrow" class="arrow-right">
        </div>
    </div>
</template>

<script>
    import right from 'public/assets/imgs/ic_more_grey.png';
    export default {
        props: {
            text: {
                type: String,
                required: true
            },
            tab: {
                type: String,
                required: false
            },
            hasArrow: {
                type: Boolean,
                default: true
            },
            url: {
                type: String,
                required: false
            },
            value: {
                type: String,
                required: false
            }

        },
        data() {
            return {
                arrow: right,
                tabIndex: 0
            }
        },
        created() {
            const tabs = this.$parent.$parent.$parent.tabs;
            if (tabs) {
                this.tabIndex = tabs.indexOf(this.tab);
            }
        },
        methods: {
            changeTab () {
                if (this.url) {
                    location.href = this.url;
                    if (this.value) {
                        this.doClickLog(this.value, {})
                    }
                    return;
                }
                if (this.tabIndex > 0) {
                    this.$root.tabIndex = this.tabIndex;
                    document.body.scrollIntoView();
                    this.doClickLog('viewAll', {
                        moudleName: this.text
                    })
                }
            },
            doClickLog(value, obj) {
                let content = {
                    value: value,
                    ext: {
                        id: '',
                        ext: Object.assign(obj, this.$root.extData),
                        pos: ''
                    }
                }
                this.$logger.click(content);
            }
        }

    };

</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

    .head-wrapper {
        .head-box {
            display: flex;
            align-items: center;
            .title {
                font-size: px2rem(57);
                font-weight: bold;
            }
            .arrow-right {
                margin-left: auto;
            }
        }
    }
</style>